import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useAccountStyles = makeStyles((theme: Theme) => ({
  tabContainer: {
    marginBottom: '1px', // space to show the Paper elevation
  },
  tabIcon: {
    marginRight: theme.spacing(1),
    marginBottom: '0 !important',
  },
  avatar: {
    color: '#fff',
    backgroundColor: theme.palette.primary.main,
  },
  counteractInnerGridNegativeMargin: {
    // todo - this can be remove when the grid components are overhaulted
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
}))
